import React, { useState } from 'react';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Card from 'components/Card/Card.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { Assignment } from '@material-ui/icons';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import Incentive from './RPContentIncentive/Incentive.js';
import { ConstantPermissions } from 'contexts/useConstant.js';
import Advance from './RPContentAdvance/Advance.js';
import Payment from './RPContentPayment/Payment.js';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold'
  }
});

const tabsComponent = [
  {
    type: 'T',
    permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_SUMMARY_SHOW,
    component: Incentive,
    label: 'Incentivos',
    hash: 'incentivo'
  },
  {
    type: 'T',
    permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_ACCOUNTING_SHOW,
    component: Advance,
    label: 'Avance',
    hash: 'avance'
  },
  {
    type: 'T',
    permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_ACCOUNTING_SHOW,
    component: Payment,
    label: 'Planilla',
    hash: 'planilla'
  }
];

export default function IncentiveRp() {
  const classes = useStyles();
  const claseStyleTab = useStyleTabs();
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const themeTab = useTheme();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  function changeHash(hash) {
    navigate(`${location.pathname}#${hash}`, { replace: true });
  }

  return (
    <div className={claseStyleTab.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          textColor="secondary"
          aria-label="Tabs"
          indicatorColor="secondary"
        >
          {tabsComponent.map((item, i) => {
            return (
              <Tab
                label={item.label}
                {...indexTab(i)}
                key={i}
                onClick={() => changeHash(item.hash)}
              />
            );
          })}
        </Tabs>
      </AppBar>

      <SwipeableViews
        axis={themeTab.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        {tabsComponent.map((item, i) => {
          return (
            <TabPanel key={i} value={value} index={i} dir={themeTab.direction}>
              <Card>
                <CardHeader icon>
                  <CardIcon color="primary">
                    <Assignment />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>Reporte de {item.label}</h4>
                </CardHeader>
                <item.component idIncentive={id} />
              </Card>
            </TabPanel>
          );
        })}
      </SwipeableViews>
    </div>
  );
}
